export default __webpack_public_path__ + "static/media/TataBus.58d31e0d.jpeg";